import { res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { inject } from "vue";
export default {
    async getInfo(): Promise<res> {
        const authority = inject("author") as any;
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/detail", null, {
                withCredentials: false,
            });

            if (authority) {
                authority.value.clfCd = response.data?.data?.clfCd;
            }

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async modifyUser(data: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/member/modify",
                {
                    name: data.name,
                    pw: data.newPw,
                    dept: data.dept,
                    position: data.position,
                    workDetail: data.workDetail,
                    twitterId: data.twitterId,
                    twitterPw: data.twitterPw,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async modifyAdmin(data: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/member/modify/" + data.idx,
                {
                    pw: data.newPw,
                    name: data.name,
                    dept: data.dept,
                    position: data.position,
                    workDetail: data.workDetail,
                    twitterId: data.twitterId,
                    twitterPw: data.twitterPw ? data.twitterPw : "",
                    isAgreement: data.approved ? 1 : null,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async addUser(data: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/member/add",
                {
                    id: data.id,
                    name: data.name,
                    pw: data.newPw,
                    dept: data.dept,
                    position: data.position,
                    workDetail: data.workDetail,
                    twitterId: data.twitterId,
                    twitterPw: data.twitterPw,
                    state: data.state,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getUserList(page: number, size: number, name: string, dept: number, position: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/member/list",
                {
                    page,
                    size,
                    name,
                    dept,
                    position,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getUserDetail(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/member/detail/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async removeUser(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`member/remove/${idx}`, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
